import { combineReducers } from 'redux';


import BookReducer from './BookReducer';
import ActiveFrameReducer from './ActiveFrameReducer';
import ViewModeReducer from './ViewModeReducer';
import GalleryVisibilityReducer from './GalleryVisibilityReducer';
import TextPlayerReducer from './TextPlayerReducer';
import VideoPlayerReducer from './VideoPlayerReducer';
import ShowTextSettingsReducer from "./ShowTextSettingsReducer";
import ControlsReducer from "./ControlsReducer";
import LoginPopupReducer from "./LoginPopupReducer";
import UnavailablePopupReducer from "./UnavailablePopupReducer";
import AppReducer from "./AppReducer";
import WidgetReducer from "./WidgetReducer";
import TrackingReducer from "./TrackingReducer";


const rootReducer = combineReducers({
    activeFrame: ActiveFrameReducer,
    app: AppReducer,
    book: BookReducer,
    controlsState: ControlsReducer,
    galleryVisibility: GalleryVisibilityReducer,
    loginPopup: LoginPopupReducer,
    showTextSettings: ShowTextSettingsReducer,
    textReader: TextPlayerReducer,
    tracking: TrackingReducer,
    unavailablePopup: UnavailablePopupReducer,
    videoPlayerState: VideoPlayerReducer,
    viewMode: ViewModeReducer,
    widget: WidgetReducer,

});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js